export default function () {
	;(function () {
		let cleanupHasRun = false

		function clearURLParams() {
			if (cleanupHasRun) {
				return
			}
			cleanupHasRun = true

			const paramsToRemove = [
				'utm_source',
				'utm_medium',
				'utm_campaign',
				'utm_term',
				'utm_content',
				'gclid',
				'fbclid',
				'msclkid',
				'edrone_id',
				'rr_id',
				'retailer_product_id',
				'c_id'
			]
			const url = new URL(window.location.href)
			let modified = false

			paramsToRemove.forEach((param) => {
				if (url.searchParams.has(param)) {
					url.searchParams.delete(param)
					modified = true
				}
			})

			if (modified) {
				window.history.replaceState({}, document.title, url.toString())
			}
		}

		document.addEventListener('fscripts-loaded', () => {
			if (window.dataLayer) {
				window.dataLayer.push({
					event: 'custom.url_cleanup_trigger',
					event_callback: () => {
						setTimeout(clearURLParams, 150)
					},
				})

				setTimeout(() => {
					if (!cleanupHasRun) {
						console.warn('GTM callback failed, cleaning URL from fallback.')
						clearURLParams()
					}
				}, 300)

			} else {
				console.warn('GTM not found after fscripts-load. Using final fallback.')
				setTimeout(clearURLParams, 500)
			}
		})
	})()
}
